/**
 * The day's 6 Deye windows against the day itself (iteration 2). Deye TOU
 * windows start at a wall-clock time (HH:MM), the contract uses hour
 * positions of the local day; a start must be expressible as a time:
 *   - inside the day (`start_hour` < 23 / 24 / 25);
 *   - not at the repeated hour of the autumn clock change: on 25.10.2026
 *     (Kyiv) positions 3 and 4 are both 03:00, a window starting at 4 would
 *     start at the first 03:00.
 */
import { formatInTimeZone } from 'date-fns-tz';
import { localDayLength, localDayStartUtc } from './time.js';
const HOUR_MS = 3_600_000;
/** Why `windows` can't be the windows of local day `ymd` in `tz`; null — they can. */
export function dayWindowsProblem(windows, ymd, tz) {
    const len = localDayLength(ymd, tz);
    const start = localDayStartUtc(ymd, tz).getTime();
    const label = (p) => formatInTimeZone(new Date(start + p * HOUR_MS), tz, 'HH:mm');
    for (const w of windows) {
        if (w.start_hour >= len)
            return `window starts at hour ${w.start_hour}, the day has ${len}`;
        if (w.start_hour > 0 && label(w.start_hour) === label(w.start_hour - 1)) {
            return `window starts at the repeated ${label(w.start_hour)} of the clock change`;
        }
    }
    return null;
}
//# sourceMappingURL=windows.js.map